// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/inventory/inventory-dialog/material-detail-dialog/material-detail-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
